import { FC, memo, useMemo } from 'react'
import styled, { useTheme } from 'styled-components';
import FeedbackIcon from '../../../../components/icons/feedback-icon';

interface BotChatMessageFeedbackFeedbackIconProps {
  onClick: () => void;
  feedback?: string;
}

export const BotChatMessageFeedbackFeedbackIcon: FC<BotChatMessageFeedbackFeedbackIconProps> = ({
  onClick,
  feedback
}) => {
  const theme = useTheme();

  const imageSrc = useMemo(() => {
    if (feedback) {
      theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.feedback?.activeSrc
    }

    return theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.feedback?.inactiveSrc
  }, [feedback, theme]);

  return (
    <Container
      onClick={onClick}
      isActive={!!feedback}
      className={`feedback_icon voa_chat_bot_message_reaction_button ${feedback ? 'selected' : ''}`}
    >
      <FeedbackIcon />
    </Container>
  )
};

  const Container = styled.button<{ isActive: boolean }>`
    && {
      ${(props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.feedback?.styles}

      svg {
        path: nth-child(n + 1) {
          stroke: ${(props) =>
            props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.outlineColor
              ? props.theme.themeConfig.chatMessages.botMessage.feedback.icons.outlineColor
              : props.isActive
                ? 'white'
                : 'black'};
        }
        path: first-child {
          stroke: ${(props) =>
            props.isActive
              ? props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.active?.styles?.fill
              : props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.outlineColor
                ? props.theme.themeConfig.chatMessages.botMessage.feedback.icons.outlineColor
                : 'black'};
          fill: ${(props) =>
            props.isActive
              ? props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.icons?.active?.styles?.fill
              : 'transparent'};
        }
      }
    }
  `
